module.exports = __webpack_public_path__ + "static/media/arrow-right.1d72c556.svg";